import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from "../../../assets/caseMappingIcon.svg";

const THREE_MINUTES = 3 * 60 * 1000;

const ReprocessButton = ({ createdAt, onRefresh }) => {
  const [showRefresh, setShowRefresh] = useState(() => {
    return Date.now() - new Date(createdAt).getTime() >= THREE_MINUTES;
  });

  useEffect(() => {
    const createdTime = new Date(createdAt).getTime();
    const remaining = THREE_MINUTES - (Date.now() - createdTime);

    if (remaining <= 0) {
      setShowRefresh(true);
      return;
    }

    setShowRefresh(false);

    const timer = setTimeout(() => {
      setShowRefresh(true);
    }, remaining);

    return () => clearTimeout(timer);
  }, [createdAt]);

  if (!showRefresh) {
    return (
      <div className="absolute top-3 right-3 z-40">
        <CircularProgress size={24} />
      </div>
    );
  }

  return (
    <div
      className="absolute top-3 right-3 z-40 cursor-pointer"
      onClick={onRefresh}
    >
      <img src={RefreshIcon} alt="refresh-icon" />
    </div>
  );
};

export default ReprocessButton;
